import Chart from 'stimulus-chartjs'
import type { ChartData } from 'chart.js'

export default class extends Chart {
  connect() {
    super.connect()
  }

  // Bind an action on this method
  async update() {
    const response = await fetch('https://example.com/chart_data.json')
    const data = (await response.json()) as ChartData

    this.chart.data = data
    this.chart.update()
  }
}
